import { styled } from "styled-components";
import ColorField from "../ColorField";

const Container = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Separator = styled.hr`
  width: 100%;
`;

export default function SecondaryThemeForm() {
  return (
    <Container>
      <h2>Secondary</h2>
      <ColorField
        label="Background"
        name="secondary.color"
        info="Sign in screen background"
        infoId="secondaryColor"
      />
      <Separator />
      <h3>Content</h3>
      <ColorField label="Default" name="secondary.content.default" />
      <ColorField
        label="Danger"
        name="secondary.content.danger"
        info="Sign in screens error messages"
        infoId="secondaryContentDanger"
      />
      <ColorField
        label="Alternative 1"
        name="secondary.content.alt_1"
        info="Account landing screen nav links"
        infoId="secondaryContentAlt1"
      />
      <ColorField
        label="Alternative 2"
        name="secondary.content.alt_2"
        info="Used in AOA for scribbles (Not used in WL)"
        infoId="secondaryContentAlt2"
      />
      <Separator />
      <h3>Highlights</h3>
      <ColorField
        label="Default"
        name="secondary.highlights.default"
        info="Sign up - Terms acceptance checkbox"
        infoId="secondaryHighlightsDefault"
      />
      <Separator />
      <h3>Buttons</h3>
      <h4>Default</h4>
      <ColorField
        label="Background"
        name="secondary.buttons.default.color"
        info="Login button background"
        infoId="secondaryButtonsDefaultColor"
      />
      <ColorField
        label="Content"
        name="secondary.buttons.default.content"
        info="Login button text"
        infoId="secondaryButtonsDefaultContent"
      />
      <h4>Alternative 1</h4>
      <ColorField
        label="Background"
        name="secondary.buttons.alt_1.color"
        info="Social sign in button background"
        infoId="secondaryButtonsAlt1Background"
      />
      <ColorField
        label="Content"
        name="secondary.buttons.alt_1.content"
        info="Social sign in button text"
        infoId="secondaryButtonsAlt1Content"
      />
      <Separator />
      <h3>Surfaces</h3>
      <h4>Default</h4>
      <ColorField
        label="Background"
        name="secondary.surfaces.default.color"
        info="Search results container background"
        infoId="secondarySurfacesDefaultBackground"
      />
      <ColorField
        label="Content  - Default"
        name="secondary.surfaces.default.content.default"
        info="Search results text color"
        infoId="secondarySurfacesDefaultContentDefault"
      />
      <ColorField
        label="Content  - Alternative 1"
        name="secondary.surfaces.default.content.alt_1"
        info="Search results text color"
        infoId="secondarySurfacesDefaultContentAlt1"
      />
    </Container>
  );
}
